module.exports = __webpack_public_path__ + "img/human_57.00382466.png";